import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import "react-phone-input-2/lib/style.css";
import Root from "./routes/root";
import { unregister } from "./serviceWorker";

ReactDOM.render(<Root />, document.getElementById("root"));
unregister();
